import {Component} from '@angular/core';
import {DocumentViewerPageComponent} from '../../shared/components/document-viewer-page/document-viewer-page.component';

@Component({
  selector: 'app-travel-report',
  templateUrl: './travel-report.component.html',
  imports: [DocumentViewerPageComponent]
})
export class TravelReportComponent {
  constructor() {
  }
}
